import React from "react";
import { useParams } from "react-router-dom";
import { CustomList } from "components";
import ReviewerEmployeeCount from "./components/reviewer-employee-count";
import { RenderProfile } from "components/render-profile";

export default function ReviewerCoverage() {
  const { quadId } = useParams();

  const columns = [
    {
      id: "reviewer",
      header: "Reviewer",
      accessorKey: "reviewer",
      cell: ({ getValue }) => <RenderProfile user={getValue()} />,
    },
    {
      id: "count",
      header: "Reviewee Count",
      accessorKey: "reviewee_count",
      cell: ({ getValue }) => getValue() || 0,
    },
  ];

  const filters = {
    quadrimesterId: quadId,
  };

  return (
    <div className="flex-1 h-full">
      <CustomList
        title="Reviewer Coverage"
        endPoint="performance-review/pending-reviewers"
        filters={filters}
        columns={columns}
        showSearch={false}
        storageKey={`reviewer-load-view-${quadId}`}
        teleportFilters={true}
        href={(item) => item.reviewer.id}
      />
    </div>
  );
}
